export const getFrameByName = (frames, name) => {
  return frames.find((frame) => frame.name === name) || null;
};
